"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LiveChatVersion;
(function (LiveChatVersion) {
    LiveChatVersion[LiveChatVersion["V1"] = 1] = "V1";
    LiveChatVersion[LiveChatVersion["V2"] = 2] = "V2";
})(LiveChatVersion || (LiveChatVersion = {}));
exports.default = LiveChatVersion;
//# sourceMappingURL=LiveChatVersion.js.map